module.exports = "<div class=\"dialog\">\n<div class=\"dialog__body\" [ngClass]=\"{'lrg': dialogSize === 'lrg', 'md': dialogSize === 'md', 'sm': dialogSize === 'sm'}\">\n    <ng-content></ng-content>\n  </div>\n</div>\n<div class=\"dialog-background\"></div>"


//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/Ovs.Resort.UI.Web/src/app/shared/basic-dialog/basic-dialog.component.html
// module id = ../../../../../src/app/shared/basic-dialog/basic-dialog.component.html
// module chunks = main